import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 59,
	viewBox: "0 0 78 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M77.3325 29.5428C77.3325 35.8307 75.7583 58.8095 38.6663 58.8095C28.0883 58.8095 0 58.92 0 58.92V29.5428C0 11.9497 14.2052 0 38.6663 0C60.0248 0 77.3325 8.7367 77.3325 29.5428Z",
		fill: "#5724E9"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28.211 33.4505C31.4056 33.4505 33.9954 27.9954 33.9954 21.2663C33.9954 14.5371 31.4056 9.08203 28.211 9.08203C25.0163 9.08203 22.4265 14.5371 22.4265 21.2663C22.4265 27.9954 25.0163 33.4505 28.211 33.4505ZM48.864 33.4511C52.0586 33.4511 54.6484 27.996 54.6484 21.2668C54.6484 14.5377 52.0586 9.0826 48.864 9.0826C45.6693 9.0826 43.0796 14.5377 43.0796 21.2668C43.0796 27.996 45.6693 33.4511 48.864 33.4511Z",
		fill: "white"
	})]
});
export default SvgBub;
